import { UserLanguage } from '../features/account/types/User'

/**
 * Map user language to backend accepted language format for translation API
 * Note: 'en' is not included as translation is only offered for non-English users
 */
export const mapUserLanguageToBackend = (userLanguage: UserLanguage): string => {
  switch (userLanguage) {
    case 'ja':
      return 'japanese'
    case 'zh':
      return 'chinese_simplified'
    default:
      return 'english'
  }
}
